import { XIcon } from '@phosphor-icons/react'
import type { ReactElement } from 'react'
import { RecipeCard } from 'app/components/lists/card/RecipeCard'
import { Button } from 'app/components/ui/button'
import type { CommContext } from 'app/hooks/usePipelineCommContext'
import type { TaskCounts } from 'app/hooks/usePipelineTaskCounts'
import type { ContactJson } from 'app/types/entities'
import { recipeFromConfig } from 'lib/cardRecipe'
import type { ListCardConfig } from 'lib/listCardConfig'

/** A custom list's card: the recipe its user configured, in the shared frame. */
export function ListSlotCard({
  contact,
  config,
  taskCounts,
  commContext,
  dragging,
  onDragStart,
  onDragEnd,
  onOpen,
  onRemove,
}: {
  contact: ContactJson
  config: ListCardConfig
  taskCounts?: TaskCounts
  commContext?: CommContext
  dragging: boolean
  onDragStart: () => void
  onDragEnd: () => void
  onOpen: () => void
  onRemove?: () => void
}): ReactElement {
  return (
    <RecipeCard
      recipe={recipeFromConfig(config)}
      subject={{ kind: `contact`, contact }}
      drag={{ dragging, onDragStart, onDragEnd }}
      onOpen={onOpen}
      href={`/contacts?drawer=${contact.id}`}
      actions={
        onRemove && (
          <Button variant="icon" size="icon-sm" aria-label="Remove from list" onClick={onRemove}>
            <XIcon size={14} weight="bold" />
          </Button>
        )
      }
      context={{ taskCounts, commContext }}
    />
  )
}
